export default {
  'app.setting.pagestyle': 'Configuració d\'estil general',
  'app.setting.pagestyle.dark': 'Estil de menú fosc',
  'app.setting.pagestyle.light': 'Estil de menú clar',
  'app.setting.content-width': 'Amplada de l\'àrea de contingut',
  'app.setting.content-width.fixed': 'Amplada fixa',
  'app.setting.content-width.fluid': 'Fluid',
  'app.setting.themecolor': 'Color del tema',
  'app.setting.themecolor.dust': 'Crepuscle',
  'app.setting.themecolor.volcano': 'Volcà',
  'app.setting.themecolor.sunset': 'Capvespre',
  'app.setting.themecolor.cyan': 'Cian brillant',
  'app.setting.themecolor.green': 'Verd aurora',
  'app.setting.themecolor.daybreak': 'Blau albada (per defecte)',
  'app.setting.themecolor.geekblue': 'Blau geek',
  'app.setting.themecolor.purple': 'Púrpura',
  'app.setting.navigationmode': 'Mode de navegació',
  'app.setting.sidemenu': 'Disposició de menú lateral',
  'app.setting.topmenu': 'Disposició de menú superior',
  'app.setting.fixedheader': 'Capçalera fixa',
  'app.setting.fixedsidebar': 'Menú lateral fix',
  'app.setting.fixedsidebar.hint': 'Configurable amb disposició de menú lateral',
  'app.setting.hideheader': 'Ocultar capçalera en desplaçar cap avall',
  'app.setting.hideheader.hint': 'Configurable amb capçalera fixa',
  'app.setting.othersettings': 'Altres configuracions',
  'app.setting.weakmode': 'Mode de daltonisme',
  'app.setting.copy': 'Copiar configuració',
  'app.setting.copyinfo':'Copiat amb èxit, aneu a config/defaultSettings.js per reemplaçar la configuració per defecte',
  'app.setting.production.hint':'La barra de configuració només s\'utilitza per a previsualització en l\'entorn de desenvolupament, no es mostrarà en l\'entorn de producció. Copieu i modifiqueu manualment el fitxer de configuració',
};
